"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Button = _ref => {
  let {
    children,
    text,
    id,
    variant,
    disabled,
    ...rest
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    id: id,
    className: "call-to-action-btn",
    ...rest,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("a", {
      href: "success",
      className: "btn btn-modern btn-primary",
      children: text ? text : children
    })
  });
};
Button.propTypes = {
  id: _propTypes.default.string,
  text: _propTypes.default.string,
  onClick: _propTypes.default.func,
  variant: _propTypes.default.oneOf(['primary', 'secondary', 'outline', 'boxed'])
};
Button.defaultProps = {
  variant: 'primary'
};
var _default = exports.default = Button;